import request from '@/utils/request'

export function login(loginfo) {
  return request({
    url: 'Security/Login',
    method: 'post',
    data: loginfo
  })
}

export function codelogin(loginfo) {
  return request({
    url: 'Security/LoginCheck',
    method: 'post',
    data: loginfo
  })
}

export function getInfo() {
  return request({
    url: 'Common/GetBaseInfo',
    method: 'get'
    // params: { token }
  })
}

export function checkUser(code) {
  return request({
    url: 'user/CheckUser',
    method: 'get',
    params: { code }
  })
}

export function resetPwdBySms(data) {
  return request({
    url: 'user/ResetPwdBySms',
    method: 'post',
    data: data
  })
}

export function logout() {
  return request({
    url: 'Security/Logout',
    method: 'post'
  })
}

export function sendvcode(mobile) {
  return request({
    url: '/common/SendVcode',
    method: 'post',
    data: mobile
  })
}

export function resetPwd(data) {
  return request({
    url: '/Security/ResetPwd',
    method: 'post',
    data: data
  })
}
export function modifyPwd(data) {
  return request({
    url: '/User/ModifyPwd',
    method: 'post',
    data: data
  })
}
export function updatepwd(updatePasswordInfo) {
  return request({
    url: '/user/updatepwd',
    method: 'post',
    data: updatePasswordInfo
  })
}

export function getvcodeimage(UserCode) {
  return request({
    url: '/Security/Captcha',
    method: 'get',
    params: { UserCode }
  })
}

export function loginSms(mobile) {
  return request({
    url: '/Security/LoginSms',
    method: 'get',
    params: { mobile }
  })
}

export function SwitchDepart(departIds) {
  return request({
    url: '/User/SwitchDepart',
    method: 'post',
    data: { departId: departIds }
  })
}

export function GetUserSelfInfo() {
  return request({
    url: '/User/GetUserSelfInfo',
    method: 'get'
  })
}

export function UpdateUserSelfInfo(datas) {
  return request({
    url: '/User/UpdateUserSelfInfo',
    method: 'post',
    data: datas
  })
}

export function ChangeUserPwd(datas) {
  return request({
    url: '/User/ChangeUserPwd',
    method: 'post',
    data: datas
  })
}

